import React, { useEffect, useState } from "react";
import Table from "../../../Utils/Table/Table1";
import { getbrokerageData, GetBonus,GetBonusInr,getbrokerageDataINR } from "../../../Services/Admin/Addmin";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import {
  AddProfitMarginApi,
  GetAdminUsername,
  getProfitMarginApi,
  GetAdminBalanceWithPosition,
} from "../../../Services/Superadmin/Superadmin";

import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { fDateTimesec } from "../../../Utils/Date_format/datefromat";
import { HandCoins } from "lucide-react";

const Brokerage = () => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [bonusData, setBonusData] = useState([]);
  const [MarginLogs, setMarginLogs] = useState([]);
  const [search, setSearch] = useState("");
  const [OpenModal, setOpenModal] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [selectedAdminId, setSelectedAdminId] = useState({});
 const [adminUsername, setAdminUsername] = useState([]);
  const [activeTab, setActiveTab] = useState("Brokerage");
  const [activeMarket, setActiveMarket] = useState("USD");
const decimalPoint = activeMarket === "INR" ? 2 : 3;
  const [BalanceData, setBalanceData] = useState({
    totalBalance: 0,
    totalOpenPosition: 0,
    totalUsersOpen: 0,
  });

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);


  useEffect(() => {
    fetchAdminUsername();
  }, []);

  const fetchAdminUsername = async () => {
    try {
      const res = await GetAdminUsername();

      setAdminUsername(res?.data || []);
    } catch (err) { }
  };

  useEffect(() => {
    if (selectedAdminId && selectedAdminId._id) {
      fetchAllData();
    }
  }, [refresh, search, selectedAdminId, page, rowsPerPage,activeMarket]);

  useEffect(() => {
    if (selectedAdminId && selectedAdminId._id) {
      GetAdminBalanceWithPositionData();
    }
  }, [selectedAdminId]);

  const GetAdminBalanceWithPositionData = async () => {
    try {
      const res = await GetAdminBalanceWithPosition({
        admin_id: selectedAdminId._id,
      });
      if (res.status) {
        const {
          totalBalance,
          totalPnL,
          userCount,
          fixedBalance,
          remainingBalance,
          TotalAdminProfit,
        } = res.data;
        setBalanceData({
          totalBalance: totalBalance || 0,
          totalOpenPosition: totalPnL || 0,
          totalUsersOpen: userCount || 0,
          TotalAdminProfit: TotalAdminProfit || 0,

          fixedBalance: fixedBalance || 0,
          remainingBalance: remainingBalance || 0,
        });
      }
    } catch (err) { }
  };

  const columns = [
    {
      Header: "S.No",
      id: "rowIndex",
      Cell: ({ index }) => (page - 1) * rowsPerPage + index + 1,
    },
    { Header: "UserName", accessor: "UserName" },
    { Header: "Symbol", accessor: "symbol" },

    {
      Header: "Brokerage",
      accessor: "brokerage",
      Cell: ({ row }) => {
        const value = parseFloat(row?.brokerage);
        if (isNaN(value)) return "-";

        return Number.isInteger(value)
          ? value.toString()
          : value.toFixed(decimalPoint).replace(/\.?0+$/, "");
      },
    },

    {
      Header: "Created At",
      accessor: "createdAt",
      Cell: ({ row }) => (row?.createdAt ? fDateTimesec(row?.createdAt) : "-"),
    },
  ];

  const columnsForBonus = [
    {
      Header: "S.No",
      id: "rowIndex",
      Cell: ({ index }) => (page - 1) * rowsPerPage + index + 1,
    },
    { Header: "UserName", accessor: "username" },
    { Header: "Bonus", accessor: "Bonus" },
    // {
    //   Header: "Type",
    //   accessor: "Type",
    //   Cell: ({ cell }) => {
    //     const typeMap = {
    //       Fund_Add: "Deposit Bonus",
    //       Fixed_PerClient: "Per Client Bonus",
    //       Every_Transaction: "Per Transaction Bonus",
    //     };
    //     return typeMap[cell?.value] || cell?.value;
    //   },
    // },

{
  Header: "Type",
  accessor: "Type",
  Cell: ({ row }) => {
    const typeMap = {
      Fund_Add: "Deposit Bonus",
      Fixed_PerClient: "Per Client Bonus",
      Every_Transaction: "Per Transaction Bonus",
    };

    return typeMap[row?.Type] || row?.Type || "-";
  },
},



    {
      Header: "Created At",
      accessor: "createdAt",
      Cell: ({ row }) => (row?.createdAt ? fDateTimesec(row?.createdAt) : "-"),
    },
  ];

  const fetchAllData = async (adminId = selectedAdminId._id) => {
    if (!adminId) return;
    try {
      // const [brokerageRes, bonusRes] = await Promise.all([
      //   getbrokerageData({
      //     admin_id: adminId,
      //     page,
      //     limit: rowsPerPage,
      //     search,
      //   }),
      //   GetBonus({
      //     admin_id: adminId,
      //     page,
      //     limit: rowsPerPage,
      //     search,
      //   }),
      // ]);


      const brokerageApi =
  activeMarket === "INR"
    ? getbrokerageDataINR
    : getbrokerageData;

const bonusApi =
  activeMarket === "INR"
    ? GetBonusInr
    : GetBonus;

const [brokerageRes, bonusRes] = await Promise.all([
  brokerageApi({
    admin_id: adminId,
    page,
    limit: rowsPerPage,
    search,
  }),

  bonusApi({
    admin_id: adminId,
    page,
    limit: rowsPerPage,
    search,
  }),
]);


      const brokerageData = brokerageRes.data || [];
      const bonusList = bonusRes.data || [];

      // Agar backend se already structure ready aa raha hai to map bhi chahiye nahi,
      // warna sirf yahi map rakho, filter mat karo:
      const formattedBrokerage = brokerageData.map((item) => ({
        UserName: item.UserName,
        symbol: item.balance_data?.symbol || "",
        Amount: item.balance_data?.Amount || 0,
        brokerage: item.balance_data?.brokerage || 0,
        createdAt: item.balance_data?.createdAt || null,
      }));

      setData(formattedBrokerage);
      setTotalPages(brokerageRes.pagination?.totalPages || 1);

      // Bonus ke liye bhi direct:
      setBonusData(bonusList);
    } catch (err) {
      Swal.fire("Error", "Failed to fetch data. Please try again.", "error");
    }
  };


  const fetchMarginLogs = async () => {
    try {
      const res = await getProfitMarginApi({ admin_id: selectedAdminId._id });
      if (res.status) {
        setMarginLogs(res.data);
      }
    } catch (err) { }
  };

  const clearBrokerage = async () => {
    let amountToClear = BalanceData.remainingBalance;
    if (amountToClear <= 0) {
      Swal.fire("Error", "No brokerage to clear.", "error");
      return;
    }

    const result = await Swal.fire({
      title: "Clear Brokerage",
      text: `Enter amount to clear (max: ${BalanceData.remainingBalance})`,
      input: "number",
      inputAttributes: {
        min: 1,
        max: BalanceData.remainingBalance,
        step: 1,
      },
      showCancelButton: true,
      confirmButtonText: "Clear",
      cancelButtonText: "Cancel",
      preConfirm: (value) => {
        const amount = parseFloat(value);
        if (
          isNaN(amount) ||
          amount <= 0 ||
          amount > BalanceData.remainingBalance
        ) {
          Swal.showValidationMessage(
            `Please enter a valid amount between 1 and ${BalanceData.remainingBalance}`
          );
          return false;
        }
        return amount;
      },
    });

    if (!result.isConfirmed) return;

    amountToClear = result?.value;

    try {
      const res = await AddProfitMarginApi({
        adminid: selectedAdminId._id,
        balance: amountToClear,
      });

      if (res.status) {
        Swal.fire(
          "Success",
          `${amountToClear} cleared successfully`,
          "success"
        );
        GetAdminBalanceWithPositionData();
      }
    } catch (err) {
      Swal.fire("Error", "Failed to clear brokerage.", "error");
    }
  };

  const handleAdminFilterChange = (e) => {
    const value = e.target?.value;

    const selected = adminUsername.find((admin) => admin.UserName === value);
    setSelectedAdminId(selected || {});
  };


  const handlePageChange = (newPage) => {
    setPage(newPage);         // Table1 prev/next se ye call karega
  };

  const handleRowsPerPageChange = (newPerPage) => {
    setRowsPerPage(newPerPage);
  };


  return (
    <div className="container-fluid mt-5">
      <div className="card shadow-sm">
        {/* Header */}
        <div className="card-header border-0 flex-wrap d-flex justify-content-between align-items-center">
          <h2 className="text-sm d-flex align-items-center gap-2 mb-0">
            <HandCoins size={24} /> Brokerage and Bonus Management
          </h2>
          <div className="wallet-tabs mt-2">
  <div className="btn-group" role="group">

    <button
      type="button"
      className={`btn ${
        activeMarket === "USD"
          ? "btn-primary"
          : "btn-outline-primary"
      }`}
      onClick={() => setActiveMarket("USD")}
    >
      <i className="fas fa-dollar-sign me-2"></i>
      USD Wallet
    </button>

    <button
      type="button"
      className={`btn ${
        activeMarket === "INR"
          ? "btn-primary"
          : "btn-outline-primary"
      }`}
      onClick={() => setActiveMarket("INR")}
    >
      <i className="fas fa-rupee-sign me-2"></i>
      INR Wallet
    </button>

  </div>
     <button
            className="btn ms-3 btn-primary"
            onClick={() => navigate(-1)}
          >
            <i className="fa-solid fa-arrow-left me-2"></i> Back
          </button>
</div>

       
        </div>

        {/* Body */}
        <div className="card-body custom-bg">
          {/* Search and Filter Section */}
          <div className="row mb-3 align-items-end">
            {/* Search Input */}
            <div className="col-md-4 mb-2">
              <label className="form-label fw-semibold text-dark">🔍 Search:</label>
              <input
                type="text"
                className="form-control shadow-sm"
                placeholder="Search by Symbol, Username, or Type..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target?.value);
                  setPage(1);
                }}
              />
            </div>

            {/* Admin Filter */}
            <div className="col-md-4 mb-2">
              <label className="form-label fw-semibold text-dark">👤 Select Admin:</label>
              <select
                className="form-select shadow-sm"
                value={selectedAdminId.UserName || ""}
                onChange={handleAdminFilterChange}
              >
                <option value="">All Admins</option>
                {adminUsername.map((admin, index) => (
                  <option key={index} value={admin.UserName}>
                    {admin.UserName}
                  </option>
                ))}
              </select>
            </div>

            {/* Action Buttons */}
            <div className="col-md-4 d-flex flex-wrap justify-content-end gap-2 mb-2">
              <button
                className="btn btn-outline-info d-flex align-items-center gap-2"
                onClick={() => {
                  setOpenModal(true);
                  fetchMarginLogs();
                }}
              >
                <i className="fa-solid fa-clock-rotate-left"></i>
                <span>View Logs</span>
              </button>

              <button
                className="btn btn-outline-success d-flex align-items-center gap-2"
                onClick={clearBrokerage}
              >
                <i className="fa-solid fa-broom"></i>
                <span>Clear All</span>
              </button>
            </div>
          </div>

          {/* Summary Cards - Using similar layout to BonusAndBrokerage */}
          <div className="row mb-3">
            {[
              { 
                label: `Total ${selectedAdminId.brokerage ? "Brokerage" : selectedAdminId.bonus ? "Bonus" : "Brokerage/Bonus"}`, 
                value: BalanceData.TotalAdminProfit || 0
              },
              { 
                label: "Remaining", 
                value: BalanceData.remainingBalance || 0
              },
              { 
                label: "Completed", 
                value: BalanceData.fixedBalance || 0
              },
            ].map((item, idx) => (
              <div key={idx} className="col-md-4">
                <div className="card border-0 shadow-lg">
                  <div className="card-body py-3">
                    <h6 className="mb-1 fw-bold">{item.label}</h6>
                    <div className="form-control-plaintext fw-semibold">
                      {typeof item?.value === 'number' ? item?.value. toFixed(decimalPoint): item?.value}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Balance Summary Cards */}
          <div className="row mb-3">
            {[
              { label: "💰 Total Balance", value: BalanceData.totalBalance, color: "primary" },
              { label: "📈 Total Open Position", value: BalanceData.totalOpenPosition, color: "warning" },
              { label: "👤 Active Users", value: BalanceData.totalUsersOpen || 0, color: "success" },
            ].map((item, idx) => (
              <div key={idx} className="col-md-4">
                <div className="card border-0 shadow-sm">
                  <div className="card-body py-3">
                    <h6 className="mb-1 fw-bold text-muted">{item.label}</h6>
                    <div className={`form-control-plaintext fw-semibold text-${item.color}`}>
                      {typeof item?.value === 'number' ? item?.value.toFixed(decimalPoint) : item?.value}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Tabs Section */}
      <Tabs
  activeKey={activeTab}
  onSelect={(k) => setActiveTab(k)}
  className="mb-3 custom-tabs"
  justify
>
  {/* Brokerage Tab */}
  <Tab eventKey="Brokerage" title="Brokerage">
    <Table
      columns={columns}
      data={data}
      page={page}
      totalPages={totalPages}
      initialRowsPerPage={rowsPerPage}
      onPageChange={handlePageChange}
      onRowsPerPageChange={handleRowsPerPageChange}
      tableClassName="table custom-header table-hover table-bordered"
    />
  </Tab>

  {/* Bonus Tab */}
  <Tab eventKey="Bonus" title="Bonus">
    <Table
      columns={columnsForBonus}
      data={bonusData}
      // page={page}
      // totalPages={totalPages}
      // initialRowsPerPage={rowsPerPage}
      // onPageChange={handlePageChange}
      // onRowsPerPageChange={handleRowsPerPageChange}
      tableClassName="table custom-header table-hover table-bordered"
    />
  </Tab>
</Tabs>
        </div>
      </div>

      {/* Modal for Logs */}
      {OpenModal && (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              height: "100vh",
              width: "100vw",
              backdropFilter: "blur(6px)",
              zIndex: 1040,
            }}
          ></div>

          <div
            className="modal show fade d-block"
            tabIndex="-1"
            style={{ zIndex: 1050 }}
          >
            <div
              className="modal-dialog modal-lg modal-dialog-centered"
              style={{ maxWidth: "800px" }}
            >
              <div
                className="modal-content"
                style={{
                  backdropFilter: "blur(10px)",
                  borderRadius: "16px",
                  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
                  border: "none",
                }}
              >
                <div
                  className="modal-header"
                  style={{ borderBottom: "1px solid rgba(0,0,0,0.1)" }}
                >
                  <h2 className="modal-title fw-bold">📝 Redeem Logs</h2>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => { setMarginLogs([]); setOpenModal(false); }}
                  ></button>
                </div>
                <div className="modal-body">
                  <table className="table table-hover table-bordered">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Amount</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {MarginLogs.length === 0 ? (
                        <tr>
                          <td colSpan="3" className="text-center text-muted">
                            No logs found.
                          </td>
                        </tr>
                      ) : (
                        MarginLogs.map((log, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              {log.balance ? log.balance.toFixed(decimalPoint) : "-"}
                            </td>
                            <td>{fDateTimesec(log.createdAt)}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Brokerage;